var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeLimitIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.36182L6.15144 10.1924C4.32488 12.0012 3.41161 12.9056 3.66728 13.6859C3.68926 13.7529 3.71656 13.8182 3.74891 13.881C4.12529 14.6118 5.41686 14.6118 8 14.6118C10.5831 14.6118 11.8747 14.6118 12.2511 13.881C12.2834 13.8182 12.3108 13.7529 12.3327 13.6859C12.5884 12.9056 11.6751 12.0012 9.84856 10.1924L8 8.36182ZM8 8.36182L9.84856 6.53124C11.6751 4.72244 12.5884 3.81805 12.3327 3.03775C12.3108 2.97067 12.2834 2.90542 12.2511 2.8426C11.8747 2.11182 10.5831 2.11182 8 2.11182C5.41686 2.11182 4.12529 2.11182 3.74891 2.8426C3.71656 2.90542 3.68926 2.97067 3.66728 3.03775C3.41161 3.81805 4.32488 4.72244 6.15144 6.53124L8 8.36182Z",
    stroke: "#1B1F3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 4.29932H9.25",
    stroke: "#1B1F3C",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 12.4243H9.25",
    stroke: "#1B1F3C",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeLimitIcon);
export default __webpack_public_path__ + "static/media/time-limit-icon.d0af8e74b2a2b5d362abca1c392daa4c.svg";
export { ForwardRef as ReactComponent };